<template>
  <div class="page_content create-section">

  <div class="page_heading">
    <div class="col-5 module_heading">
      <span class="module_icon icon-mentor"></span>
            <span class="module_title">Create Employer</span>
    </div>

    <div class="col-7 btn_container">
      <button v-on:click="validateEmployer" class="btn btn-primary" aria-label="save">save</button>
      <button v-on:click="cancel" class="btn btn-primary" aria-label="cancel">cancel</button>
      </div>
    </div>
  <div class="content-section">
    <div class="row content-row">
      <div class="col-6 row">
        <div class="col-4 form-label" id="title">Title <sup>*</sup></div>
        <div class="col-7"><input v-model="employer.title" aria-labelledby="title" placeholder="Title" required></div>
      </div>
      <div class="col-6 row">
        <div class="col-4 form-label" id="externalId">External Id<sup>*</sup></div>
        <div class="col-7"><input v-model="employer.externalId" aria-labelledby="externalId" placeholder="External Id" type="text" required></div>
      </div>
    </div>

    <div class="row content-row">
      <div class="col-6 row">
        <div class="col-4 form-label" id="firstName">External URL</div>
        <div class="col-7"><input v-model="employer.externalUrl" aria-labelledby="externalUrl" placeholder="External Url"></div>

      </div>
      <div class="col-6 row">
        <div class="col-4 form-label" id="contactEmail">Contact Email</div>
        <div class="col-7"><input v-model="employer.contactEmail" aria-labelledby="contactEmail" placeholder="Contact Email"></div>
      </div>
    </div>

    <div class="row content-row">
      <div class="col-6 row">
        <div class="col-4 form-label" id="contactPhone">Contact Phone</div>
        <div class="col-7"><input v-model="employer.contactPhone" aria-labelledby="contactPhone" placeholder="Contact Phone"></div>
      </div>
      <div class="col-6 row">
        <div class="col-4 form-label" id="description">Description</div>
        <div class="col-7"><textarea v-model="employer.description" aria-labelledby="description"></textarea></div>
      </div>
    </div>

    <div class="row content-row">
      <div class="col-6 row">
        <div class="col-4 form-label" id="mission">Mission</div>
        <div class="col-7"><textarea v-model="employer.mission" aria-labelledby="mission"></textarea></div>
      </div>
    </div>

  </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'employerCreate',
  props: [],
  components: {
  },
  data: () => {
    return {
      employer: {
        title: '',
        externalId: '',
        description: '',
        externalUrl: '',
        mission: '',
        contactEmail: '',
        contactPhone: '',
        institutionId: ''
      }
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCreateEmployer'
    ]),
    validateEmployer () {
      if (this.employer.title.length > 0 && this.employer.externalId.length > 0) {
        this.createEmployer()
      } else {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Title and External Id are required.'
        })
      }
    },
    createEmployer () {
      this.employer.institutionId = this.currentInstitutionId
      this.loadCreateEmployer({employer: this.employer}).then(res => {
        if (res) {
          this.$router.push({ name: 'employerAdmin' })
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully created employer.'
          })
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Please try again.'
          })
        }
      })
    },
    cancel () {
      this.$router.push({ name: 'employerAdmin' })
    }

  },

  computed: {
    ...mapState({
    }),
    currentInstitutionId () {
      var userObj = JSON.parse(localStorage.getItem('userobj'))
      return userObj.institutionId
    }
  },

  watch: {
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/employer/components/EmployerCreate.vue